import React, { useState } from 'react';
import logo from '@assets/images/logo.svg';
import { HashLink as Link } from 'react-router-hash-link';
import Modal from '@components/Modal/Modal';
import Popup from '@components/Modal/Popup';
import ArtistMenu from '@components/Modal/ArtistMenu';
import FundMenu from '@components/Modal/FundMenu';
import ham from '@assets/images/ham_burger.svg';

const Header = () => {
  const [showArtistModal, setShowArtistModal] = useState(false);
  const [showFundModal, setShowFundModal] = useState(false);
  const toggleArtistModal = () => {
    setShowArtistModal(!showArtistModal);
  };
  const toggleFundModal = () => {
    setShowFundModal(!showFundModal);
  };

  const renderArtistModal = () => {
    return (
      <Modal show={showArtistModal}>
        <Popup>
          <ArtistMenu onClose={toggleArtistModal} />
        </Popup>
      </Modal>
    );
  };

  const renderFundModal = () => {
    return (
      <Modal show={showFundModal}>
        <Popup>
          <FundMenu onClose={toggleFundModal} />
        </Popup>
      </Modal>
    );
  };
  const openMenu = () => {
    document.getElementById('sidenav').style.width = '70%';
  };

  const closeMenu = () => {
    document.getElementById('sidenav').style.width = '0px';
  };

  return (
    <header>
      <nav className='navbar'>
        <div className='nav__mobile-box'>
          <a href={'/'} rel='noreferrer'>
            <img className='nav__logo' src={logo} alt='logo' />
          </a>
          <img src={ham} className='ham_menu' alt='' onClick={openMenu} />
        </div>
        <div className='nav__menu-box'>
          <ul className='nav__menu-items'>
            <Link to='/about'>
              <li className='nav__menu-item'>About</li>
            </Link>
            <Link
              to={import.meta.env.VITE_CREATOR_TOOLS_LINK}
              smooth
              offset={500}
              duration={500}
              className='nav__menu-item'
              target='_blank'
              rel='noopener noreferrer'
            >
              <li className='nav__menu-item'> Creator Tools </li>
            </Link>
          </ul>
        </div>
        <div id='sidenav' className='nav__menu-box'>
          <button className='closebtn' onClick={closeMenu}>
            &times;
          </button>
          <ul className='nav__menu-items'>
            <Link
              to='/#home'
              smooth
              offset={500}
              duration={500}
              className='nav__menu-item-box'
            >
              <li className='nav__menu-item'> Home </li>
            </Link>
            <Link
              to='/about'
              smooth
              offset={500}
              duration={500}
              className='nav__menu-item-box'
            >
              <li className='nav__menu-item'> About </li>
            </Link>
            <Link
              to={import.meta.env.VITE_CREATOR_TOOLS_LINK}
              smooth
              offset={500}
              duration={500}
              className='nav__menu-item-box'
              target='_blank'
              rel='noopener noreferrer'
            >
              <li className='nav__menu-item'> Creator Tools </li>
            </Link>
          </ul>
        </div>
      </nav>
      {renderArtistModal()}
      {renderFundModal()}
    </header>
  );
};

export default Header;
